<section class="py-20">
  <div class="max-w-5xl mx-auto px-14">
    <div class="grid items-end grid-cols-1 gap-16 text-center md:grid-cols-2">
      <!-- 1200+ -->
      <div class="flex flex-col items-center">
        <div class="flex items-center font-extrabold text-(--color-main) leading-none" dir="ltr">
          <span class="text-[80px]">2000</span>
          <span class="ml-1 text-[50px] self-center">+</span>
        </div>

        <p class="mt-2 text-xl text-white md:text-2xl">متعاقد نشط</p>
      </div>

      <!-- 45 -->
      <div class="flex flex-col items-center">
        <div class="flex items-center font-extrabold text-(--color-main) leading-none" dir="ltr">
          <span class="text-[80px]">85</span>
          <span class="ml-1 text-[50px] self-center">+</span>
        </div>

        <p class="mt-2 text-xl text-white md:text-2xl">مشروع زراعي ممول</p>
      </div>
    </div>
  </div>
</section>
